export default __webpack_public_path__ + "static/media/fcd1594c4385433faa6a22cb137c92ec1577099108267.2bf9adfa.webp";